<script setup lang="ts">
import { computed, type ShallowRef } from "vue";

import { resolveComponent } from "@/components/Mosaic/MosaicResolver";

import { useMosaicStore } from "@/stores/mosaic-store";

defineOptions({ inheritAttrs: false });

const props = defineProps<{ componentName: string; componentRef?: ShallowRef }>();
const slots = defineSlots<Record<string, (props?: Record<string, unknown>) => unknown>>();

const mosaicStore = useMosaicStore();

const component = computed(() => resolveComponent(props.componentName, mosaicStore.activeStack.list));
</script>
<template>
  <component :is="component" :ref="componentRef" v-bind="$attrs">
    <template v-for="(_, slotName) in slots" #[slotName]="slotProps">
      <slot :name="slotName" v-bind="slotProps ?? {}" />
    </template>
  </component>
</template>
